export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("apollo:error", async (error) => {
    // await navigateTo("/auth/login", { replace: true });
  });
});
